// Shared by Studio, Movis and the image worker. Keep provider dimensions in one place.
export const IMAGE_MODELS = [
  { id: 'sana', name: 'Sana', references: false },
  { id: 'gpt-image-2', name: 'GPT Image 2', references: true },
  { id: 'gpt-image-2.5-flare', name: 'GPT Image 2.5 Flare', references: true },
  { id: 'gpt-image-2.5-sunburst', name: 'GPT Image 2.5 Sunburst', references: true },
  { id: 'grok', name: 'Grok Imagine', references: true },
];
export const IMAGE_RATIOS = ['1:1', '4:3', '3:4', '16:9', '9:16'];
export const MAX_IMAGE_REFERENCES = 3;
export function imageModelPolicy(id) {
  id = String(id || '').toLowerCase();
  const alias = { 'sana-sprint-1.6b': 'sana', 'grok-imagine': 'grok' };
  const model = IMAGE_MODELS.find(item => item.id === (alias[id] || id));
  if (!model) throw new Error('ไม่รองรับโมเดลภาพที่เลือก');
  return model;
}
export function imageGenerationSize(model, ratio = '1:1') {
  const policy = imageModelPolicy(model);
  const sizes = policy.id === 'sana'
    ? [[1024,1024],[1024,768],[768,1024],[1024,576],[576,1024]]
    : [[1024,1024],[1344,1008],[1008,1344],[1536,864],[864,1536]];
  const index = IMAGE_RATIOS.indexOf(ratio);
  if (index < 0) throw new Error('ไม่รองรับสัดส่วนภาพนี้');
  const [width, height] = sizes[index];
  return { width, height, aspectRatio: ratio };
}
export function composeImagePrompt(prompt, style = '') {
  let text = String(prompt || '').trim();
  const suffix = String(style || '').trim();
  if (!text) throw new Error('กรุณาเขียน Prompt ก่อนสร้างภาพ');
  // Idempotent when an older caller already included the category instruction.
  if (suffix && text.endsWith(suffix)) text = text.slice(0, -suffix.length).replace(/[,\s]+$/, '');
  const result = suffix ? (text ? `${text}\n\n\n${suffix}` : suffix) : text;
  if (result.length > 8000) throw new Error('Prompt รวมสไตล์ต้องไม่เกิน 8,000 ตัวอักษร');
  return result;
}
export function validateImageReferences(model, ids = []) {
  if (!Array.isArray(ids) || ids.length > MAX_IMAGE_REFERENCES || ids.some(id => typeof id !== 'string' || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id))) throw new Error('ภาพอ้างอิงไม่ถูกต้อง (สูงสุด 3 ภาพ)');
  if (ids.length && !imageModelPolicy(model).references) throw new Error('โมเดลนี้ไม่รองรับภาพอ้างอิง กรุณาเลือก GPT Image หรือ Grok');
  return [...new Set(ids)];
}
